import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;

/**
 * RUM is initialized only when credentials are provided. In practice only the
 * production env file sets them, so staging/dev stay silent unless a developer
 * opts in locally (e.g. via .env.local) to validate instrumentation.
 */
export const isDatadogRumEnabled = Boolean(applicationId && clientToken);

if (isDatadogRumEnabled) {
  datadogRum.init({
    applicationId: applicationId as string,
    clientToken: clientToken as string,
    site: "datadoghq.com",
    service: "web-backoffice",
    env: import.meta.env.VITE_NODE_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: "mask-user-input",
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    // Propagate trace headers to our APIs so frontend RUM connects to backend
    // APM traces once the backend is instrumented.
    allowedTracingUrls: [
      {
        match: /^https:\/\/[^/]*\.woba\.com\.br(\/|$)/,
        propagatorTypes: ["datadog", "tracecontext"],
      },
      {
        match: /^https:\/\/[^/]*\.beerorcoffee\.com(\/|$)/,
        propagatorTypes: ["datadog", "tracecontext"],
      },
    ],
    plugins: [reactPlugin()],
  });
}

/**
 * Associate the active RUM session with the authenticated user. Sends only the
 * user id — no name/email — to avoid exporting PII to Datadog (LGPD). No-op
 * when RUM is disabled.
 */
export const identifyDatadogUser = (user: { id: string }) => {
  if (!isDatadogRumEnabled) return;
  datadogRum.setUser({ id: user.id });
};
